import { createAction } from 'redux-actions';

const actions = {
  /**
   *  추천 태그 데이터 변경하기
   */
  SET_DATA: 'recommend/tag/SET_DATA',
  setData: createAction('recommend/tag/SET_DATA'),

  /**
   *  추천 태그 리스트 가져오기
   */
  GET_TAG_REVIEW_LIST_REQUEST: 'recommend/tag/GET_TAG_REVIEW_LIST_REQUEST',
  GET_TAG_REVIEW_LIST_SUCCESS: 'recommend/tag/GET_TAG_REVIEW_LIST_SUCCESS',
  getTagReviewList: createAction('recommend/tag/GET_TAG_REVIEW_LIST_REQUEST'),

  /**
   *  추천 태그 상세 요청하기
   */
  GET_RECOMMEND_TAG_DETAIL_REQUEST: 'recommend/tag/GET_RECOMMEND_TAG_DETAIL_REQUEST',
  GET_RECOMMEND_TAG_DETAIL_SUCCESS: 'recommend/tag/GET_RECOMMEND_TAG_DETAIL_SUCCESS',
  getRecommendTagDetail: createAction('recommend/tag/GET_RECOMMEND_TAG_DETAIL_REQUEST'),

  /**
   *  추천 태그 복사하기 전 필요한 데이터 가져오기
   */
  PREPARE_COPY_RECOMMEND_TAG_REQUEST: 'recommend/tag/PREPARE_COPY_RECOMMEND_TAG_REQUEST',
  PREPARE_COPY_RECOMMEND_TAG_SUCCESS: 'recommend/tag/PREPARE_COPY_RECOMMEND_TAG_SUCCESS',
  prepareCopyTagReview: createAction('recommend/tag/PREPARE_COPY_RECOMMEND_TAG_REQUEST'),

  /**
   *  추천 태그 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_CREATE_RECOMMEND_TAG_REQUEST: 'recommend/tag/PREPARE_CREATE_RECOMMEND_TAG_REQUEST',
  PREPARE_CREATE_RECOMMEND_TAG_SUCCESS: 'recommend/tag/PREPARE_CREATE_RECOMMEND_TAG_SUCCESS',
  prepareCreateTagReview: createAction('recommend/tag/PREPARE_CREATE_RECOMMEND_TAG_REQUEST'),

  /**
   *  추천 태그에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_TAG_ITEM_REQUEST: 'recommend/tag/GET_RECOMMEND_TAG_ITEM_REQUEST',
  GET_RECOMMEND_TAG_ITEM_SUCCESS: 'recommend/tag/GET_RECOMMEND_TAG_ITEM_SUCCESS',
  getRecommendTagItemList: createAction('recommend/tag/GET_RECOMMEND_TAG_ITEM_REQUEST'),

  /**
   *  추천 태그 등록/복사하기
   */
  CREATE_RECOMMEND_TAG_REQUEST: 'recommend/tag/CREATE_RECOMMEND_TAG_REQUEST',
  createRecommendTag: createAction('recommend/tag/CREATE_RECOMMEND_TAG_REQUEST'),

  /**
   *  전체 태그 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/tag/GET_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getRecommendTagItemListExcelDownload: createAction(
    'recommend/tag/GET_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  선택된 태그 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/tag/GET_SELECTED_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedRecommendTagItemListExcelDownload: createAction(
    'recommend/tag/GET_SELECTED_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  태그 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST: 'recommend/tag/SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_SUCCESS: 'recommend/tag/SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_SUCCESS',
  setRecommendTagItemListExcelUpload: createAction('recommend/tag/SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST'),
};

export default actions;
